/*
 *
 * AbsenceDetail reducer
 *
 */
import produce from 'immer';
import {
  LOAD_ABSENCE,
  LOAD_ABSENCE_SUCCESS,
  LOAD_ABSENCE_ERROR,
  CHANGE_ABSENCE,
  CHANGE_ABSENCE_SUCCESS,
  CHANGE_ABSENCE_ERROR,
  DELETE_ABSENCE,
  DELETE_ABSENCE_SUCCESS,
  DELETE_ABSENCE_ERROR,
  FLUSH_STATE_ABSENCEDETAIL,
} from './constants';

export const initialState = {
  // loading
  loading: false,
  loadingDelete: false,
  loadingUpdate: false,
  // errors
  error: false,
  // success props
  deleteSuccessful: false,
  absenceData: false,
};

/* eslint-disable default-case, no-param-reassign */
const absenceReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_ABSENCEDETAIL:
        return initialState;
      
      // Load All
      case LOAD_ABSENCE:
        draft.loading = true;
        draft.error = false;
        draft.id = action.id;
        break;

      case LOAD_ABSENCE_SUCCESS:
        draft.absenceData = action.absenceData;
        draft.loading = false;
        break;

      case LOAD_ABSENCE_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.absenceData = false;
        break;
    
      
      // Update for Single Element
      case CHANGE_ABSENCE:
        draft.absenceData = { ...state.absenceData, ...action.absenceData };
        draft.loadingUpdate = true;
        draft.error = false;
        break;

      case CHANGE_ABSENCE_SUCCESS:
        draft.loadingUpdate = false;
        draft.absenceData = { ...state.absenceData, ...action.absenceData };
        break;

      case CHANGE_ABSENCE_ERROR:
        draft.error = action.dataErerrorror;
        draft.loadingUpdate = false;
        break;
      
      
      // Delete for Single Element
      case DELETE_ABSENCE:
        draft.loadingDelete = true;
        draft.deleteSuccessful = false;
        break;

      case DELETE_ABSENCE_SUCCESS:
        draft.loadingDelete = false;
        draft.deleteSuccessful = true;
        break;
    }
  });

export default absenceReducer;
